import { render, staticRenderFns } from "./AddBranchModal.vue?vue&type=template&id=adcdbc3c&"
import script from "./AddBranchModal.vue?vue&type=script&lang=js&"
export * from "./AddBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports